










































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import Pool from "./pool/Pool.vue";
import ButtonGroup from "./buttonGroup/ButtonGroup.vue";
import * as types from "@/store/constants/types";
import * as statusConst from "@/store/constants/status";
import GeneralUtilsHelper from "@/utils/generalUtils";
import Nav from "@/components/nav/navBar.vue";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";
import * as AppLifeCycle from "@/utils/appLifeCycle";
import NumUtils from "@/utils/numUtils";
import EventBus from "@/utils/eventBus";
import CountDownManager from "./EarnCoinCountDown";
import localStorageHelper from "@/localstorage/localstorage";
import Http from "@/api/http/fetch/index";
import { isIos } from "@/utils/lodash";
import {
  AnalyticsHelperEl,
  FEED_COINS_TEMPORARY
} from "@/utils/analyticsHelper";
import LaunchUtils from "@/utils/launchUtils";

@Component({
  components: {
    Nav,
    Pool,
    ButtonGroup
  }
})
export default class EarnCoin extends Vue {
  @Action(types.ACT_FEED)
  private actFeed: any;
  @Action(types.SKIP_FEED)
  private skipFeed: any;
  @Action(types.REQUEST_FEEDS)
  private requestFeed: any;
  @Action(types.ROUTER_PUSH)
  private routerPush: any;
  @Action(types.PAY_BY_ANY)
  private payByAny: any;
  @Getter(types.GETTER_CURRENT_FEED)
  private currentFeed: any;
  @Getter(types.GETTER_VALID_USER_STATUS)
  private validUserStatus: any;
  @Getter(types.GETTER_RETRY_FEED_OFFER)
  private getterRetryFeedOffer: any;
  @Getter(types.GETTER_SETTING_DATA)
  private settingData: any;
  @Getter(types.GETTER_MASTER_COINS)
  private userCoins: any;
  @Mutation(types.UPDATE_USER_STATUS)
  private updateUserStatus: any;
  @Mutation(types.GET_FEEDS)
  private getFeeds: any;
  @Action(types.DIALOG_SHOW)
  private dialogShow: any;
  @Getter(types.GETTER_EARN_COIN_USER_LIST)
  private earnCoinUserList: any;
  @Getter(types.GETTER_EARN_COINS_GREEN_LIGHT)
  private earnCoinsGreenLight: any;
  @Action(types.START_INSTALL_SUPER_PAY_APP)
  private startInstallSuperPayApp: any;
  @Action(types.START_INSTALL_BACK_UP_APP)
  private startInstallBackUpApp: any;
  @Getter(types.GETTER_MASTER_ID)
  private masterId: any;
  @Action(types.REQUEST_ADMOB_AVAILABLE)
  private requestAdmobAvailable: any;
  @Action(types.WATCH_VIDEO)
  private watchVideo: any;

  /**
   * 监听各类的data,判断设置当前的status状态，将状态传入子组件，再由子组件进行判断
   */

  //当前传下去的status状态：
  private status: any = "";

  private limitedCountNum: number = 0;
  private limitedIntervalTimer: any = null;
  private limitedCountDownEndTimeStamp: number = 0;

  private vipCountDownTime: number = 0; //vip的倒计时时间
  private vipCountDownIntervalTimer: any = null; //vip的倒计时 timer
  private vipCountDownEndTimeStamp: number = 0; //vip的倒计时的时间戳

  private showLimitCoin: any = false; //是否显示limited coins
  private retryTimes: number = 0; //池子空的次数

  private startSpacingThrold: number = 0; //计数 >num
  private earnFeedSpacingCountNum: number = 0; //spacing倒计时数
  private fkTimer: any = null; //计时器timer 用于点击后停顿的计时器

  private skipDelayTimer: any = null; //用于skip的timer的计时器
  private skipDelayCountNum: number = 0; //计数器

  private randomFeedCoinsStatus: number = 1;

  private feedCionKeyName: any = ["big_sale", "mega_sale", "crazy_sale"];
  private newFeedCoinsArr: any = [];
  private feedCoinsIndex: number = 0;

  private videoName = "free_coins";
  private admob_enabled: boolean = false;
  private hasRequst: boolean = false;

  @Watch("currentFeed", { immediate: true })
  private currentFeedChange(val: any, oldVal: any) {
    console.log("currentFeedChange:", {
      val,
      oldVal
    });

    if (this.status !== statusConst.TIME_LIMIT) {
      if (val && oldVal) {
        //都存在的情况下：
        if (val.feed_id !== oldVal.feed_id) {
          this.nomalizeFeedStatus(val);
        } else {
          console.log("发现了相同feed_id,不变化");
        }
      } else {
        this.nomalizeFeedStatus(val);
      }
    }
  }

  @Watch("workingUserList", { immediate: true })
  private workingUserListChange(val: any, oldVal: any) {
    console.log("workingUserListChange:", {
      val,
      oldVal
    });

    //如果有一个可用的用户，执行正常化的Pool:
    if (val && val.length > 0) {
      //TODO earn coins时候会导致重复触发:
      console.log("如果有一个或者多个可用的用户:", {
        val,
        oldVal
      });
      if (oldVal && val.length !== oldVal.length) {
        console.log("workingUserListChange触发了nomalizeFeedStatus");
        this.nomalizeFeedStatus(this.currentFeed);
      } else if (oldVal === undefined) {
        console.log("workingUserListChange old触发了nomalizeFeedStatus");
        this.nomalizeFeedStatus(this.currentFeed);
      }
    } else if (val && val.length === 0) {
      console.log("如果没有可用的用户:", {
        val,
        oldVal
      });
      this.emptyWorkingUserProcess();
    }
  }

  get currentFeedData() {
    return this.currentFeed
      ? this.currentFeed
      : {
          offer: {},
          kind: "",
          sub_kind: ""
        };
  }

  get workingUserList() {
    return this.earnCoinUserList("working");
  }

  get restrictedUserList() {
    return this.earnCoinUserList("restricted");
  }

  get format() {
    return NumUtils.format;
  }

  get watchVideoReward() {
    return this.settingData.rewards.video;
  }

  get earnFeedSpacingTimeDefault() {
    return this.settingData.earn_limit.earn_feed_spacing_time
      ? this.settingData.earn_limit.earn_feed_spacing_time
      : 3;
  }

  get earnFeedSpacingCountDefault() {
    return this.settingData.earn_limit.earn_feed_spacing_threshhold
      ? this.settingData.earn_limit.earn_feed_spacing_threshhold
      : 10;
  }

  get earnAdsAutoPlayEnable() {
    //是否自动播放视频
    return this.settingData.earn_limit.auto_play_video_ads_enabled
      ? this.settingData.earn_limit.auto_play_video_ads_enabled
      : false;
  }

  private clickCasino() {
    this.routerPush({
      name: "Casino",
      params: {
        routerTransition: "forward"
      }
    });
  }

  private clickNavCoin() {
    this.routerPush({
      name: "CoinsStore",
      params: {
        routerTransition: "up"
      }
    });
  }

  private emptyWorkingUserProcess() {
    //判断是否有limited用户，如果有limited用户，取limited用户中时间最短的去显示：
    //或者有warning或者colding用户：
    const limitedUserList = this.restrictedUserList.filter((user: any) => {
      return (
        (user.restrictedType &&
          user.restrictedType === statusConst.TIME_LIMIT &&
          user.limitedEndTimeStamp > new Date().valueOf()) ||
        (user.restrictedType &&
          (user.restrictedType === statusConst.COLDING ||
            user.restrictedType === statusConst.WARNING) &&
          user.punish_expire > new Date().valueOf())
      );
    });
    if (!limitedUserList || limitedUserList.length === 0) {
      console.log("找不到TIME_LIMIT用户");
      this.nomalizeFeedStatus(this.currentFeed);
    } else {
      //将punish_expire变为limitedEndTimeStamp:
      const newLimitedUserList = limitedUserList.map((limitedUser: any) => {
        return limitedUser.punish_expire
          ? {
              ...limitedUser,
              limitedEndTimeStamp: limitedUser.punish_expire
            }
          : limitedUser;
      });

      //取出时间戳最近的：
      let minLimitedUser = newLimitedUserList[0];
      for (const user of newLimitedUserList) {
        if (user.limitedEndTimeStamp < minLimitedUser.limitedEndTimeStamp) {
          minLimitedUser = user;
        }
      }
      console.log("找到时间最短的minLimitedUser:", minLimitedUser);
      this.startLimitedCountDown(minLimitedUser.limitedEndTimeStamp);
    }
  }

  /**
   *  ================ 开始 limited count down 倒计时 ====================
   */
  private startLimitedCountDown(limitedEndTimeStamp: number) {
    this.clearLimitedCountDown();
    this.status = statusConst.TIME_LIMIT;
    this.limitedCountDownEndTimeStamp = limitedEndTimeStamp;

    const diffTime = Math.round(
      (limitedEndTimeStamp - new Date().valueOf()) / 1000
    );
    console.log("开始limted的倒计时：", {
      diffTime,
      limitedEndTimeStamp
    });
    if (diffTime <= 1) {
      //如果时间已经过了：
      console.log("如果时间已经过了：");
      this.clearLimitedCountDown();
    } else {
      //如果没有超时，需要刷新timer:
      this.limitedCountDownListenAppLifeCycle();
      this.limitedCountNum = diffTime;
      this.limitedIntervalTimer = setInterval(() => {
        this.limitedCountNum -= 1;
        console.log("limitedCountNum:", this.limitedCountNum);
        if (this.limitedCountNum <= 0) {
          console.log("limited的倒计时结束：");
          this.clearLimitedCountDown();
        }
      }, 1000);
    }
  }

  /**
   *  停止并清除limited count down 倒计时
   */
  private clearLimitedCountDown() {
    clearInterval(this.limitedIntervalTimer);
    this.limitedIntervalTimer = null;
    this.limitedCountDownRemoveListenrAppLifeCycle();
  }

  private limitedCountDownListenAppLifeCycle() {
    console.log("limitedCountDownListenAppLifeCycle添加");
    AppLifeCycle.addListener({
      key: "limitedCountDownListenAppLifeCycle",
      fn: async () => {
        console.log("切换至前台检查limited的倒计时是否还在继续");
        if (this.limitedIntervalTimer !== null) {
          const diffTime = Math.floor(
            (this.limitedCountDownEndTimeStamp - new Date().valueOf()) / 1000
          );
          if (diffTime <= 1) {
            //如果时间已经过了：
            console.log("如果时间已经过了：");
            this.clearLimitedCountDown();
          } else {
            //如果没有超时，需要刷新timer:
            console.log(
              "如果没有超时，需要刷新limited的 timer:",
              this.limitedCountDownEndTimeStamp
            );
            this.startLimitedCountDown(this.limitedCountDownEndTimeStamp);
          }
        } else {
          this.limitedCountDownRemoveListenrAppLifeCycle();
        }
        this.limitedCountDownRemoveListenrAppLifeCycle();
      }
    });
  }

  private limitedCountDownRemoveListenrAppLifeCycle() {
    console.log("清除掉limited的前后台切换倒计时");
    AppLifeCycle.removeListener("limitedCountDownListenAppLifeCycle");
  }

  /**
   *  将用户的状态置为正常
   */
  private normalizeUserStatus(userId: number) {
    const newUserStatus = {
      userId,
      status: statusConst.NORMAL,
      limitedEndTimeStamp: null
    };
    this.updateUserStatus(newUserStatus);
  }

  private countRetryNum(currentFeed: any) {
    //计算出再次retyr的次数：
    if (currentFeed.retry_offer) {
      console.log("countRetryNum +1》》》");
      this.retryTimes += 1;
    }
  }

  /**
   *  ================ 正常化本地的池子的状态 ====================
   */
  private nomalizeFeedStatus(currentFeed: any) {
    this.clearLimitedCountDown();

    if (currentFeed == null) {
      //池子内为空
      console.log("池子内为空：》》》》》");
      //先计数，如果次数连续超过两次则还是让他显示retry
      if (this.retryTimes >= 2) {
        this.retryTimes = 0;
        this.status = statusConst.FEED_EMPTY;
        return;
      }
      //如果只是第一次，commit一个正常的offer feed进入池子
      if (!this.earnCoinsGreenLight()) {
        //不支持权重：
        this.status = statusConst.FEED_EMPTY;
      } else {
        //支持权重：
        this.getFeeds([this.getterRetryFeedOffer()]);
      }
    } else if (
      currentFeed.kind === "offer" &&
      currentFeed.feed_id.indexOf("coin") > -1
    ) {
      //为feed_coin的offer
      if (this.status !== statusConst.FEED_COIN) {
        this.status = statusConst.FEED_COIN;
        this.countRetryNum(currentFeed);
        this.randomFeedCoinsStatusProcess();
      }
      //打点：
      // sendEvent("uia_feed_coins_show", "");
    } else if (
      currentFeed.kind === "offer" &&
      currentFeed.feed_id.indexOf("vip") > -1
    ) {
      //为feed_coin的offer
      this.status = statusConst.FEED_VIP;
      this.countRetryNum(currentFeed);
      //如果还在计时则不管,除非没有在计时：
      // if (this.vipCountDownIntervalTimer === null) {
      //   this.startVipCountDown();
      // }
      //打点：
      sendEvent("uia_vip_1mo_show", "earn_coins_feed");
      sendEventWithParams("uia_vip_other_show", { place: "earn_coins_feed" });
      LaunchUtils.setBuyVipFrom("earn_coins_feed");
    } else if (
      currentFeed.kind === "offer" &&
      currentFeed.offer &&
      currentFeed.offer.kind === "feed_casino_slots"
    ) {
      //casino slots
      this.status = statusConst.FEED_CASINO_SLOTS;
    } else if (
      currentFeed.kind === "offer" &&
      currentFeed.offer &&
      currentFeed.offer.kind === "feed_casino_sic"
    ) {
      //casino slots
      this.status = statusConst.FEED_CASINO_SIC;
    } else if (
      currentFeed.kind === "offer" &&
      currentFeed.offer &&
      currentFeed.offer.kind === "feed_casino_spin"
    ) {
      //casino slots
      this.status = statusConst.FEED_CASINO_SPIN;
    } else if (
      currentFeed.kind === "offer" &&
      currentFeed.offer &&
      currentFeed.offer.kind === "feed_video_ad"
    ) {
      //广告
      this.status = statusConst.FEED_AD;
      //如果是广告的话:
      this.autoPlayAds();
    } else if (
      currentFeed.kind === "offer" &&
      currentFeed.offer &&
      currentFeed.offer.kind === "feed_lucky_coin"
    ) {
      //lucky coins
      this.status = statusConst.FEED_LUCKY_COIN;
    } else if (
      currentFeed.kind === "offer" &&
      currentFeed.offer &&
      currentFeed.offer.kind === "feed_super_pay"
    ) {
      //super pay:
      this.status = statusConst.FEED_SUPER_PAY;
      sendEvent("uia_superapp_recommend_show", "earn_coins");
    } else if (
      currentFeed.kind === "offer" &&
      currentFeed.offer &&
      currentFeed.offer.kind === "feed_back_up"
    ) {
      //back up:
      this.status = statusConst.FEED_BACK_UP;
      sendEvent("uia_backup_recommend_show", "earn_coins");
    } else {
      //为最普通的feed
      this.status = statusConst.FEED_NORMAL;
    }

    if (currentFeed !== null) {
      this.skipTimeCount(); //正常的feed执行倒计时避免用户skip
    }
  }

  //============================== AUTO PLAY ADS =======================
  private autoPlayAds() {
    if (this.earnAdsAutoPlayEnable) {
      this.clickWatchVideo();
    }
  }

  //============================= SKIP TIME =============================

  private skipTimeCount() {
    if (this.skipDelayTimer === null) {
      if (
        this.currentFeed.offer &&
        this.currentFeed.offer.green_light &&
        this.currentFeed.offer.green_light.skip_delay &&
        this.currentFeed.offer.green_light.skip_delay >= 2
      ) {
        this.skipDelayCountNum = this.currentFeed.offer.green_light.skip_delay;
        this.startSkipTimeCount();
      } else if (
        this.currentFeed.offer &&
        this.currentFeed.offer.green_light &&
        this.currentFeed.offer.green_light.skip_delay &&
        this.currentFeed.offer.green_light.skip_delay < 2
      ) {
        //如果有配置并且小于2就do nothing:
      } else {
        //如果没有默认值的话，默认Feed coins >3s
        if (
          this.currentFeed.kind === "offer" &&
          this.currentFeed.feed_id.indexOf("coin") > -1
        ) {
          this.skipDelayCountNum = 3;
          this.startSkipTimeCount();
        }
      }
    }
  }

  private startSkipTimeCount() {
    this.skipDelayTimer = setInterval(() => {
      this.skipDelayCountNum -= 1;
      console.log("skipDelayCountNum:", this.skipDelayCountNum);
      if (this.skipDelayCountNum <= 0) {
        this.clearSkipTimeCount();
      }
    }, 1000);
  }

  private clearSkipTimeCount() {
    clearInterval(this.skipDelayTimer);
    this.skipDelayTimer = null;
    this.skipDelayCountNum = 0;
  }

  //============================ SPACING TIME ===========================
  private spacingTimeCount() {
    this.startSpacingThrold += 1; //增加计数
    if (
      this.startSpacingThrold >= this.earnFeedSpacingCountDefault &&
      this.earnFeedSpacingTimeDefault > 1 &&
      this.fkTimer === null
    ) {
      this.earnFeedSpacingCountNum = this.earnFeedSpacingTimeDefault;
      this.fkTimer = setInterval(() => {
        this.earnFeedSpacingCountNum -= 1;
        if (this.earnFeedSpacingCountNum <= 0) {
          clearInterval(this.fkTimer);
          this.fkTimer = null;
        }
      }, 1000);
    }
  }

  //=============================== VIP 倒计时 =============================

  private startVipCountDown(continueTime: number = 30) {
    //开始30秒的倒计时：
    this.clearVipCountDownProcess();
    this.vipCountDownTime = continueTime;
    this.vipCountDownEndTimeStamp = new Date().valueOf() + 30 * 1000;
    this.vipCountDownListenAppLifeCycle(); //开始监听前后台的切换

    console.log("开始vipCountDownTime:", {
      vipCountDownEndTimeStamp: this.vipCountDownEndTimeStamp,
      vipCountDownIntervalTimer: this.vipCountDownIntervalTimer,
      vipCountDownTime: this.vipCountDownTime
    });

    this.vipCountDownIntervalTimer = setInterval(() => {
      this.vipCountDownTime -= 1;
      if (this.vipCountDownTime <= 0) {
        console.log("vipCountDownTime结束:", this.vipCountDownTime);
        this.vipCountDownSkipProcess();
      }
    }, 1000);

    console.log("开始后初始化timer后:", {
      vipCountDownEndTimeStamp: this.vipCountDownEndTimeStamp,
      vipCountDownIntervalTimer: this.vipCountDownIntervalTimer
    });

    EventBus.$on("skip-vip-feed", () => {
      this.vipCountDownSkipProcess();
    });
  }

  private vipCountDownSkipProcess() {
    this.clearVipCountDownProcess();
    this.skipFeed();
  }

  private clearVipCountDownProcess() {
    clearInterval(this.vipCountDownIntervalTimer);
    this.vipCountDownIntervalTimer = null;
    this.vipCountDownRemoveListenrAppLifeCycle();
    EventBus.$off("skip-vip-feed");
  }

  private vipCountDownListenAppLifeCycle() {
    //先清除，避免多次添加
    AppLifeCycle.addListener({
      key: "vipCountDownListenAppLifeCycle",
      fn: async () => {
        console.log("切换至前台检查vip的倒计时是否还在继续");
        if (this.vipCountDownIntervalTimer !== null) {
          const diffTime = Math.floor(
            (this.vipCountDownEndTimeStamp - new Date().valueOf()) / 1000
          );
          if (diffTime < 1) {
            //如果时间已经过了：
            console.log("如果时间已经过了：");
            this.clearVipCountDownProcess();
            this.skipFeed();
          } else {
            //如果没有超时，需要刷新timer:
            console.log("如果没有超时，需要刷新timer:", diffTime);
            this.startVipCountDown(diffTime);
          }
        } else {
          this.vipCountDownRemoveListenrAppLifeCycle();
        }
        //执行完后要清除,避免多次切换
        this.vipCountDownRemoveListenrAppLifeCycle();
      }
    });
  }

  private vipCountDownRemoveListenrAppLifeCycle() {
    console.log("清除掉vip的前后台切换倒计时");
    AppLifeCycle.removeListener("vipCountDownListenAppLifeCycle");
  }

  private feedCoinsClickAnalytics() {
    if (this.feedCoinsIndex === 0) {
      sendEvent(
        "uia_feed0_coins_click",
        this.feedCionKeyName[this.randomFeedCoinsStatus - 1]
      );
    } else if (this.feedCoinsIndex === 1) {
      sendEvent(
        "uia_feed1_coins_click",
        this.feedCionKeyName[this.randomFeedCoinsStatus - 1]
      );
    } else {
      sendEvent(
        "uia_feed2_coins_click",
        this.feedCionKeyName[this.randomFeedCoinsStatus - 1]
      );
    }
  }

  private randomFeedCoinsStatusProcess() {
    //产生一个1-3的随机数，日乐购了：
    this.randomFeedCoinsStatus = Math.floor(Math.random() * 3) + 1;
    console.log(
      "触发了randomFeedCoinsStatusProcess,计算出randomNum:",
      this.randomFeedCoinsStatus
    );
    //打点 show:
    if (this.newFeedCoinsArr.length === 0) {
      const { feed_coin_offers } = this.settingData;
      const newFeedCoinsArr = feed_coin_offers.filter((feed: any) => {
        return feed.kind === "feed_coin";
      });

      this.newFeedCoinsArr = this.bubbleSort(newFeedCoinsArr);
    }

    for (const i in this.newFeedCoinsArr) {
      if (
        this.newFeedCoinsArr[i].offer_id === this.currentFeedData.offer.offer_id
      ) {
        this.feedCoinsIndex = parseInt(i);
        break;
      }
    }

    if (this.feedCoinsIndex === 0) {
      sendEvent(
        "uia_feed0_coins_show",
        this.feedCionKeyName[this.randomFeedCoinsStatus - 1]
      );
      AnalyticsHelperEl.setKey(FEED_COINS_TEMPORARY, {
        key: "uia_feed0_coins_show",
        value: this.feedCionKeyName[this.randomFeedCoinsStatus - 1]
      });
    } else if (this.feedCoinsIndex === 1) {
      sendEvent(
        "uia_feed1_coins_show",
        this.feedCionKeyName[this.randomFeedCoinsStatus - 1]
      );
      AnalyticsHelperEl.setKey(FEED_COINS_TEMPORARY, {
        key: "uia_feed1_coins_show",
        value: this.feedCionKeyName[this.randomFeedCoinsStatus - 1]
      });
    } else {
      sendEvent(
        "uia_feed2_coins_show",
        this.feedCionKeyName[this.randomFeedCoinsStatus - 1]
      );
      AnalyticsHelperEl.setKey(FEED_COINS_TEMPORARY, {
        key: "uia_feed2_coins_show",
        value: this.feedCionKeyName[this.randomFeedCoinsStatus - 1]
      });
    }
  }

  private bubbleSort = (arr: any) => {
    //排序
    const len = arr.length;
    for (let i = 0; i < len; i++) {
      for (let j = 0; j < len - 1 - i; j++) {
        if (arr[j].effect > arr[j + 1].effect) {
          //相邻元素两两对比
          const temp = arr[j + 1]; //元素交换
          arr[j + 1] = arr[j];
          arr[j] = temp;
        }
      }
    }
    return arr;
  };

  /**
   *  ==================== 中间的点击逻辑 ====================
   */
  private midButtonClickLogic() {
    if (this.status === statusConst.FEED_NORMAL) {
      //普通的feed
      this.actFeed(this.currentFeed);
      this.spacingTimeCount();
      //打点
      sendEvent("uia_earn_button_click", "");
    } else if (this.status === statusConst.FEED_EMPTY) {
      //当期feed 为空
      this.requestFeed();
    } else if (this.status === statusConst.FEED_COIN) {
      //为feed coins类型
      this.payByAny({
        offer: this.currentFeed.offer
      }).catch((err: any) => {});
      //打点：
      this.feedCoinsClickAnalytics();
    } else if (this.status === statusConst.FEED_VIP) {
      //为feed vip类型，取service offer里面的第一个进行跳转：
      const { service_offers } = this.settingData;
      this.payByAny({
        offer: service_offers[0]
      }).catch((err: any) => {});
      //打点
      sendEvent("uia_vip_1mo_click", "earn_coins_feed");
      sendEventWithParams("uia_vip_other_click", { place: "earn_coins_feed" });
      LaunchUtils.setBuyVipFrom("earn_coins_feed");
    } else if (this.status === statusConst.TIME_LIMIT) {
      //限时状态
      this.routerPush({
        name: "Login",
        params: {
          routerTransition: "up"
        }
      });
    } else if (this.status === statusConst.FEED_AD) {
      //点击广告：
      this.clickWatchVideo();
    } else if (this.status === statusConst.FEED_CASINO_SLOTS) {
      //老虎机
      this.clickCasinoAction("slots");
    } else if (this.status === statusConst.FEED_CASINO_SIC) {
      //筛子
      this.clickCasinoAction("sic_bo");
    } else if (this.status === statusConst.FEED_CASINO_SPIN) {
      //转盘
      this.clickCasinoAction("spin");
    } else if (this.status === statusConst.FEED_LUCKY_COIN) {
      //luck coins
      //点击直接进行购买：
      const { lucky_coin_offers } = this.settingData;
      this.payByAny({
        offer: lucky_coin_offers[0]
      }).catch((err: any) => {});
    } else if (this.status === statusConst.FEED_SUPER_PAY) {
      this.startInstallSuperPayApp({
        type: "static",
        ga: "earn_coins"
      });
    } else if (this.status === statusConst.FEED_BACK_UP) {
      this.startInstallBackUpApp({
        type: "static",
        ga: "earn_coins"
      });
    }
  }

  private clickPool() {
    //点击中间区域的逻辑：
    if (this.status === statusConst.FEED_COIN) {
      //为feed coins类型
      this.payByAny({
        offer: this.currentFeed.offer
      }).catch((err: any) => {});
      this.feedCoinsClickAnalytics();
    } else if (this.status === statusConst.FEED_LUCKY_COIN) {
      //luck coins
      //点击直接进行购买：
      const { lucky_coin_offers } = this.settingData;
      this.payByAny({
        offer: lucky_coin_offers[0]
      }).catch((err: any) => {});
    } else if (this.status === statusConst.FEED_VIP) {
      const { service_offers } = this.settingData;
      this.payByAny({
        offer: service_offers[0]
      }).catch((err: any) => {});
      //打点
      sendEvent("uia_vip_1mo_click", "earn_coins_feed");
      sendEventWithParams("uia_vip_other_click", { place: "earn_coins_feed" });
      LaunchUtils.setBuyVipFrom("earn_coins_feed");
    }
  }

  private clickLeft() {
    this.skipFeed();

    //清除vip count down：
    if (this.vipCountDownIntervalTimer !== null) {
      this.clearVipCountDownProcess();
    }
  }

  private clickMid() {
    //如果未登录：
    this.midButtonClickLogic();
  }

  private clickRight() {
    //加速模式 turbo more
    if (this.status === statusConst.FEED_COIN) {
      // 支付
      this.payByAny({
        offer: this.currentFeed.offer
      }).catch((err: any) => {});
    } else if (this.status === statusConst.FEED_CASINO_SLOTS) {
      //老虎机
      this.clickCasinoAction("slots");
    } else if (this.status === statusConst.FEED_CASINO_SIC) {
      //筛子
      this.clickCasinoAction("sic_bo");
    } else if (this.status === statusConst.FEED_CASINO_SPIN) {
      //转盘
      this.clickCasinoAction("spin");
    } else if (this.status === statusConst.FEED_LUCKY_COIN) {
      const { lucky_coin_offers } = this.settingData;
      this.payByAny({
        offer: lucky_coin_offers[0]
      }).catch((err: any) => {});
    } else if (this.status === statusConst.FEED_VIP) {
      //为feed vip类型，取service offer里面的第一个进行跳转：
      this.routerPush({
        name: "VipCenter",
        params: {
          routerTransition: "up",
          type: "multiple"
        },
        query: {
          type: "multiple"
        }
      });
    } else if (this.status === statusConst.FEED_SUPER_PAY) {
      this.startInstallSuperPayApp({
        type: "static",
        ga: "earn_coins"
      });
    } else if (this.status === statusConst.FEED_BACK_UP) {
      this.startInstallBackUpApp({
        type: "static",
        ga: "earn_coins"
      });
    } else {
      this.routerPush({
        name: "TurboMode",
        params: {
          routerTransition: "forward"
        }
      });
    }
  }

  private clickCasinoAction(game: string) {
    this.routerPush({
      name: "Casino",
      params: {
        routerTransition: "up",
        game,
        goNow: true
      }
    });
  }

  private async clickWatchVideo() {
    console.log("clickWatchVideo");

    if (!this.hasRequst) {
      this.admob_enabled = await this.requestAdmobAvailable();
      this.hasRequst = true;
    }

    this.watchVideo({
      videoName: this.videoName,
      admob_enabled: this.admob_enabled,
      reward: true,
      callback: this.skipFeed
    });
  }

  private loginDialog() {
    this.dialogShow();
  }

  private mounted() {
    //开始自己的倒计时计时
    CountDownManager.initialCountDownManager();
    //android:
    if (!isIos()) {
      this.requestFeed();
    }
  }

  private destroyed() {
    this.clearLimitedCountDown();
    this.clearVipCountDownProcess();
  }
}
